import React from 'react';

import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ICar, ISessionKey } from '@share/common-types';
import { IMarginatorState, marginatorActions, ILoginState, ILocationsState, carsActions, ICarsDriverState, ICarLocationsState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { NULL_VALUE } from '@constants';
import { formatDateCheckInOut, renderNumber, UrlUtils, LoginType, GetNumber } from '@share/utils';
import {
  PeopleSvg,
  SuitecaseSvg,
  TransmitionSvg,
  AirSvg,
} from '@assets';
import './style.scss';

import { DATE_FORMAT_CHECK_IN_OUT, LOCATION_OBJECT_LABEL } from '@constants';
import { get } from 'lodash';
import { DownLoadShareType, HandleDownload } from '@share/api';
import { Modal, Spin, Tooltip } from 'antd';import { BlueButton } from '@share/components';
import { Currency } from '@components';
import { HasPermission, ViewQuotesSharePermission, openCarPage } from '@utils';
import { ModalShare } from '../../../common';
import { getCarCompareRoutePath } from '@share/utils';
const modalWidth = 900;
const percents = 100;
interface IMapStateToProps {
  marginatorStore: IMarginatorState;
  loginStore: ILoginState;
  locationsStore: ILocationsState;
  carsLocationsStore: ICarLocationsState;
  carsDriverStore : ICarsDriverState
}

interface IMapDispatchToProps {
  setCommission: (value: number) => void;
  setSelectedCar: (car: ICar) => void;
}

interface IProps extends IMapDispatchToProps, IMapStateToProps, WrappedComponentProps, RouteComponentProps {
  visible: boolean;
  checkIn: string;
  checkOut: string;
  locationCode: string;
  sessionKey: ISessionKey | null | undefined;
  cars: ICar[];

  onCancel: () => void;
  onRemove: (car: ICar) => void;
}

interface IState {
  loading: boolean;
  visibleAction: boolean;
  isShare: boolean;
}

class ModalCompareComponent extends React.Component<IProps, IState> {

  state: IState = { loading: false, visibleAction: false, isShare: false };

  
  handleView = (car: ICar, marginatorCommission: number) => {
    this.props.setCommission(marginatorCommission);
    this.props.setSelectedCar(car);
    const { account } = this.props.loginStore;
    openCarPage(car.id, this.props.history, !!account?.disableNewTabOpen, !!account?.forceIframe);
  }

  handleData = (members?: string[], comment?: string) => {
    const { sessionKey, checkIn, checkOut, locationCode, cars, marginatorStore, loginStore, carsLocationsStore, carsDriverStore } = this.props;
    const { driverAge, driverCountry } = carsDriverStore;

    const { pickUp } = carsLocationsStore;
    const locationPickUp = pickUp?.location;
    const { value } = marginatorStore;
    const { account } = loginStore;
    const search = UrlUtils.getUrl(LOCATION_OBJECT_LABEL, this.props.locationsStore.selectedLocation);
    const locationObject = search.split('&').find(x => x.includes("locationObject"))?.substring(15);
    const isB2C = account?.isB2C;

    const data = {
      quotes: cars.map(car => {
        const marginatorPrice = car.price / (1 - (value / 100));
        const publicPrice = (isB2C || !car.publicPrices?.length) ? null : Math.min(...car.publicPrices.map(p => p.price));
        const CarRoutePath= getCarCompareRoutePath(car.id)
        const CarfullPath = `{0}{1}${CarRoutePath}`;
        const IsRefundable= car.refundable;

        return ({
          carId: car.id,
          displayName: car.vehicle?.vehMakeModel?.name,
          Category: car.vehicle?.category || NULL_VALUE,
          currency: car.currency,
          price: marginatorPrice,
          RentalCompany: car.vendor?.value || NULL_VALUE,
          RentalCompanyLogo: car?.info?.tpA_Extensions?.supplierLogo?.url || NULL_VALUE,
          publicPrice,
          IsRefundable,
          image: car.vehicle?.pictureURL,
          features: {
            seats: Number(car.vehicle?.passengerQuantity) || null,
            luggage: Number(car.vehicle?.baggageQuantity) || null,
            doors: Number(car.vehicle?.vehType?.doorCount) || null,
            airConditioning: car.vehicle?.airConditionInd,
            unlimitedMileage : true
          },
          pickUpDate: checkIn,
          dropOffDate: checkOut,
          pickUpLocation :car.pickUpLocationDetail?.name,
          dropOffLocation : car.dropOffLocationDetail?.name,
          driverAge: 22,
          Link: CarfullPath,
        });
      }),
      comment,
      members,
      location: locationObject,
      carRequest: {
        pickUpDate: checkIn,
        pickUpTime: new Date(cars[0]?.pickUpLocationDetail?.dateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit',hour12: false }),
        pickUpLocation: cars[0]?.pickUpLocationDetail?.locationCode,
        pickUpType: locationPickUp?.type,
        returnDate: checkOut,
        returnTime: new Date(cars[0]?.dropOffLocationDetail?.dateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        returnLocation: locationCode,
        countryISO: driverCountry,
        driverAge: GetNumber(driverAge),
        quantity: 1
      },
      sessionKey
    };

    return data;
  }

  handleLoading = () => {
    this.setState({ loading: false })
  }
  handleComplete = () => {
    this.setState({ visibleAction: false})
  }


  handleDownload = () => {
    const loading = this.state.loading;
    this.setState({ loading: true });
    HandleDownload(DownLoadShareType.CAR, loading, this.handleData(), this.props.intl, this.handleLoading, this.handleComplete);
  }

  render(): React.ReactNode {
    const {
      visible,
      cars,
      checkIn,
      checkOut,
      onCancel,
      onRemove
    } = this.props;
    const { loading } = this.state;
    const { user, account } = this.props.loginStore;

    const isB2C = account?.isB2C;
    return (
      <Modal
        className="modal-compare"
        open={visible}
        footer={null}
        onCancel={onCancel}
        wrapClassName="modal-compare__wrapper"
        width={modalWidth}
      >
        <div>
          <h4 className="modal-compare__title text-center">
            <FormattedMessage id="results.cars.card.compare.modal.title" />
          </h4>

          <div className="modal-compare__hotels" style={{ flexDirection: 'column' }}>
            <div className="hotels-dates text-center">
              {formatDateCheckInOut(checkIn, DATE_FORMAT_CHECK_IN_OUT)} - {formatDateCheckInOut(checkOut, DATE_FORMAT_CHECK_IN_OUT)}
            </div>
          </div>

          <div className="modal-compare__hotels">
           {cars.map((car, index) => {
              const { price } = car;
              const { value } = this.props.marginatorStore;
              const marginatorPrice = price / (1 - (value / 100));
              const marginatorCommission = marginatorPrice - price;

              const publicPrice = (isB2C || !car.publicPrices?.length) ? null : Math.min(...car.publicPrices.map(p => p.price))


              const msave = publicPrice ? (marginatorPrice * percents) / publicPrice : 100;
              const savings = Math.floor(percents - msave);
              const logoUrl = car?.info?.tpA_Extensions?.supplierLogo?.url || '';

              return (
                <div
                  key={index}
                  className={`modal-compare__hotel ${index === 0 ? 'display-border' : ''} hotel_${
                    cars.length
                  }`}
                >
                  <div className="hotel-images-container hotelImageHeight">
                    <div
                      className="hotel-image"
                      style={{
                        backgroundImage: `url(${
                          car.vehicle?.pictureURL || get(car, 'images[0].url')
                        })`,
                      }}
                    ></div>
                  </div>

                  <div
                    className="hotel-text-container"
                    style={{ minHeight: '20px', height: 'auto' }}
                  >
                    <p
                      className="mb-0"
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        lineClamp: 1,
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {logoUrl ? (
                          <div className="cars-content-location__vendor">
                            <img alt="Vendor logo" src={logoUrl} style={{ maxWidth: '100%', height: 'auto' }} />
                          </div>
                        ) : (
                          <span>{car?.vehicle?.vehMakeModel?.name || '-'}</span>
                        )}
                    </p>
                  </div>
                  <div className="hotel-text-container" style={{ minHeight: '20px', height: 'auto' }}>
                    <p className='mb-0'
                      style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          lineClamp: 1,
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                      }}>
                      <Tooltip title={car.vehicle?.vehMakeModel?.name} placement="top">{car.vehicle?.vehMakeModel?.name}
                      </Tooltip>
                    </p>
                  </div>

                  <div className="hotel-text-container" style={{ minHeight: '20px', height: 'auto' }}>
                    <p
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        lineClamp: 1,
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                      }}><Tooltip title={`${car.vendor?.value} ${car.pickUpLocationDetail?.name}`} placement="top">{car.vendor?.value}  {car.pickUpLocationDetail?.name}</Tooltip>
                      </p>
                  </div>

                  <div className="hotel-text-container" style={{minHeight: '50px', height: 'auto'}}>
                    <div className="cars-card__item"><TransmitionSvg /><label className='ms-1'>{car.vehicle?.transmissionType}</label></div>
                    <div className="cars-card__item"><PeopleSvg /><label className='ms-1'><FormattedMessage id='cars.filter.seats'/>: {car.vehicle?.passengerQuantity}</label></div>
                    <div className="cars-card__item"><SuitecaseSvg /><label className='ms-1'><FormattedMessage id="adult" values={{ count: car.vehicle?.passengerQuantity }} />: {car.vehicle?.passengerQuantity}</label></div>
                    <div className="cars-card__item"><SuitecaseSvg /><label className='ms-1'><FormattedMessage id='cars.baggage'/>: {car.vehicle?.baggageQuantity}</label></div>
                    <div className="cars-card__item"><AirSvg /><label className='ms-1'><FormattedMessage id='cars.ac'/></label></div>
                  </div>

                  <div className="hotel-text-container text-center" style={{ height: '43px' }}>
                    <div className="hotel-card-wrapper__refundable justify-content-center">
                      {car.refundable ? (
                        <div className="hotel-card-wrapper__refundable-ref justify-content-center">
                          <FormattedMessage id="refundable" />
                        </div>
                      ) : (
                        <div className="hotel-card-wrapper__refundable-nonref">
                          <FormattedMessage id="non.refundable" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="hotel-text-container h-auto text-center">
                    {publicPrice ? (
                      <p className="mb-0" style={{ textDecoration: 'line-through' }}>
                        <Currency currency={car.currency} />
                        {renderNumber(publicPrice, 2)}
                      </p>
                    ) : null}
                    <p className="mb-0">
                      <strong style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <Currency currency={car.currency} />
                        {renderNumber(marginatorPrice, 2)}
                      </strong>
                    </p>
                    {savings > 0 ? (
                      <p className="mb-0">
                        {savings.toFixed(0)} %{' '}
                        <FormattedMessage id="results.cars.card.compare.modal.off" />
                      </p>
                    ) : null}
                  </div>

                  <div className="hotel-view-container">
                    <div
                      className="view-button"
                      onClick={() => this.handleView(car, marginatorCommission)}
                    >
                      <FormattedMessage id="results.cars.card.compare.modal.view" />
                    </div>
                  </div>

                  <div className="hotel-remove-container">
                    <label
                      className={`${cars.length === 2 ? 'disabled' : ''}`}
                      onClick={() => {
                        if (cars.length > 2) {
                          onRemove(car);
                        }
                      }}
                    >
                      <FormattedMessage id="remove" />
                    </label>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="modal-compare__buttons">
            {(!account || account.type !== LoginType.PrivateWithToken)
              ?
              account?.displayShareCompareCars && (
                <BlueButton disabled={loading} onClick={this.handleDownload}>
                  {loading ? (<Spin />) : <FormattedMessage id="results.cars.card.compare.modal.download" />}
                </BlueButton>)
              :
              <>
                {account?.displayShareCompareCars && (
                  <BlueButton disabled={loading} onClick={() => this.setState({ visibleAction: true, isShare: false })}>
                    {loading ? (<Spin />) : <FormattedMessage id="results.cars.card.compare.modal.download" />}
                  </BlueButton>)}

                {HasPermission(user, ViewQuotesSharePermission)?
                  <BlueButton disabled={loading} onClick={() => this.setState({ visibleAction: true, isShare: true })}>
                    {loading ? (<Spin />) : <FormattedMessage id="results.cars.card.compare.modal.share" />}
                  </BlueButton> : null} 
              </>
            }
          </div>
        </div>

        <ModalShare
          visible={this.state.visibleAction}
          isShare={this.state.isShare}
          type={DownLoadShareType.CAR}
          onCancel={() => this.setState({ visibleAction: false})}
          onLoading={(loading) => this.setState({ loading })}
          convertData={this.handleData}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    marginatorStore: state.marginatorStore,
    loginStore: state.loginStore,
    locationsStore: state.locationsStore,
    carsLocationsStore : state.carsLocationsStore,
    carsDriverStore : state.carsDriverStore,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  setCommission: (value: number) => {
    dispatch(marginatorActions.setCommission(value));
  },
  setSelectedCar: (car: ICar) => {
    dispatch(carsActions.setSelectedCar(car));
  },
});

export const ModalCompare = connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(ModalCompareComponent)));